<template>
  <div class="bg-stand" style="height: 100%;overflow-y: hidden">
    <top-header></top-header>
    <div class="container-fluid" style="height: calc(100vh - 4.5rem)">
      <div class="col-12" style="height: 100%">
        <div class="row top-navbar">
          <div @click.self="toggleFileNav" class="col-2 h-100" :class="{ 'show': showFileNav }">
            <sidebar :class="{ 'show': showFileNav }" @toggleFileNav="toggleFileNav"></sidebar>
          </div>
          <div class="col-10" style="border-left: 1px solid #CED8E1; padding: 0;">
            <template v-if="!$store.getters.FILE_ACTION">
              <div class="row drive-header">
                <div class="col-2 d-flex align-items-center">
                  <button @click="toggleFileNav" class="btn mr-2 px-0 d-md-none">
                    <ListIcon />
                  </button>
                  <template v-if="$store.getters.GET_PATH.length">
                    <h6 class="mb-0 text-truncate" style="font-weight: bold"
                      :title="$store.getters.GET_CURRENT_DIRECTORY">{{ $store.getters.GET_CURRENT_DIRECTORY }}</h6>
                  </template>
                  <template v-else>
                    <h6 class="mb-0 text-truncate" style="font-weight: bold" title="Home">Home</h6>
                  </template>
                </div>
                <div class="col-6 pr-0 d-flex flex-row justify-content-end align-items-center"
                  :class="{ 'active': searchActive }">
                  <span class="user-search-icons" style="position: relative;">
                    <span @click="toggleSearchActive" class="close-search">✖</span>
                    <input type="text" placeholder="Search in My Files" v-model="type_term" @keypress="typeterm"
                      v-on-clickaway="hide_select_file" class="serach-user-box" @click="show_select_file" />
                    <img src="@/assets/SearchBar.svg" class="search-bar-icon" />
                    <span :class="{ 'filter-icon-p': advanced_search, 'filter-icon': !advanced_search }"
                      @click="show_advanced_search">
                      <img src="@/assets/filter-icon.svg" />
                    </span>

                    <div class="search-dropdown" @click="closelistdown" v-if="select_file">
                      <ul v-on-clickaway="hide_select_file">
                        <li data-text="Folders"><img src="@/assets/search-icons/Folder.svg" /> &nbsp;&nbsp;Folders</li>
                        <li data-text="PDF"><img src="@/assets/search-icons/PDF.svg" /> &nbsp;&nbsp;PDFs</li>
                        <li data-text="Word Document"><img src="@/assets/search-icons/Doc.svg" /> &nbsp;&nbsp;Word
                          Document</li>
                        <li data-text="Sheets Document"><img src="@/assets/search-icons/XLS.svg"> &nbsp;&nbsp;Sheet
                          Document</li>
                        <li data-text="Presentation Document"><img src="@/assets/search-icons/PPT.svg" />
                          &nbsp;&nbsp;Presentation Document</li>
                        <li data-text="Compressed File"><img src="@/assets/search-icons/Rar.svg" /> &nbsp;&nbsp;Compressed
                          File</li>
                        <li data-text="Images"><img src="@/assets/search-icons/Image.svg" /> &nbsp;&nbsp;Images</li>
                        <li data-text="Text"><img src="@/assets/icons/icon/TXT.svg" width="22px" height="22px" />
                          &nbsp;&nbsp;Text File</li>
                        <li data-text="Videos"><img src="@/assets/search-icons/Video.svg" /> &nbsp;&nbsp;Video</li>
                        <li data-text="Audios"><img src="@/assets/icons/icon/Mp3.svg" width="22px" height="22px" />
                          &nbsp;&nbsp;Audio</li>
                      </ul>
                    </div>
                    <div class="search-advanced-dropdown" v-on-clickaway="hide_advanced_search" v-if="advanced_search">
                      <div class="d-flex justify-content-between align-items-center mb-2">
                        <h6>Advanced Search</h6>
                        <span class="close_advanced_search" @click="hide_advanced_search">
                          <img src="@/assets/search-icons/Close.svg" />
                        </span>
                      </div>
                      <div class="row my-3">
                        <div class="col-md-4 col-sm-12 d-flex align-items-center">
                          <label class="m-0">File Name</label>
                        </div>
                        <div class="col-md-8 col-sm-12">
                          <input v-model="filename" type="text" placeholder="Enter file name" class="inp-field" />
                        </div>
                      </div>
                      <div class="row my-3">
                        <div class="col-md-4 col-sm-12 d-flex align-items-center">
                          <label class="m-0">Type</label>
                        </div>
                        <div class="col-md-8 col-sm-12" style="position: relative" v-click-outside="hide_doctype">
                          <span class="d-flex justify-content-between align-items-center in-field" @click="showtype">
                            <span>{{ filetype }}</span>
                            <span>
                              <img src="@/assets/search-icons/chevron-down.svg" :class="{ 'rotate-90': doctype }" />
                            </span>
                          </span>
                          <div class="advanced-search-dropdown" v-if="doctype" @click="select_filetype">
                            <ul>
                              <li data-text="All"><img src="@/assets/search-icons/Unkown File.svg" width="18px"
                                  height="auto" /> &nbsp;&nbsp;All</li>
                              <li data-text="Folders"><img src="@/assets/search-icons/Folder.svg" width="18px"
                                  height="auto" /> &nbsp;&nbsp;Folders</li>
                              <li data-text="PDF"><img src="@/assets/search-icons/PDF.svg" width="19px" height="auto" />
                                &nbsp;&nbsp;PDFs</li>
                              <li data-text="Word Document"><img src="@/assets/search-icons/Doc.svg" width="19px"
                                  height="auto" /> &nbsp;&nbsp;Word Document</li>
                              <li data-text="Sheets Document"><img src="@/assets/search-icons/XLS.svg" width="19px"
                                  height="auto"> &nbsp;&nbsp;Sheet Document</li>
                              <li data-text="Presentation Document"><img src="@/assets/search-icons/PPT.svg" width="19px"
                                  height="auto" /> &nbsp;&nbsp;Presentation Document</li>
                              <li data-text="Compressed File"><img src="@/assets/search-icons/Rar.svg" width="19px"
                                  height="auto" /> &nbsp;&nbsp;Compressed File</li>
                              <li data-text="Images"><img src="@/assets/search-icons/Image.svg" width="19px"
                                  height="auto" /> &nbsp;&nbsp;Images</li>
                              <li data-text="Text"><img src="@/assets/icons/icon/TXT.svg" width="19px" height="auto" />
                                &nbsp;&nbsp;Text File</li>
                              <li data-text="Videos"><img src="@/assets/search-icons/Video.svg" width="19px"
                                  height="auto" /> &nbsp;&nbsp;Video</li>
                              <li data-text="Audios"><img src="@/assets/icons/icon/Mp3.svg" width="19px" height="auto" />
                                &nbsp;&nbsp;Audio</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div class="row my-3">
                        <div class="col-md-4 col-sm-12 d-flex align-items-center">
                          <label class="m-0">Owner</label>
                        </div>
                        <div class="col-md-8 col-sm-12" style="position: relative" v-click-outside="hide_owner">
                          <span class="d-flex justify-content-between align-items-center in-field" @click="showowner">
                            <span>{{ fileowner }}</span>
                            <span>
                              <img src="@/assets/search-icons/chevron-down.svg" :class="{ 'rotate-90': doctype }" />
                            </span>
                          </span>
                          <ul class="menu" v-if="file_owner" @click="select_fileowner">
                            <li data-text="Owned by me">
                              <svg style="width:20px;height:20px" viewBox="0 0 24 24">
                                <path fill="#999"
                                  d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z" />
                              </svg>
                              &nbsp;&nbsp;Owned by me
                            </li>
                            <li data-text="Shared with me">
                              <svg style="width:20px;height:20px" viewBox="0 0 24 24">
                                <path fill="#999"
                                  d="M12,5A3.5,3.5 0 0,0 8.5,8.5A3.5,3.5 0 0,0 12,12A3.5,3.5 0 0,0 15.5,8.5A3.5,3.5 0 0,0 12,5M12,7A1.5,1.5 0 0,1 13.5,8.5A1.5,1.5 0 0,1 12,10A1.5,1.5 0 0,1 10.5,8.5A1.5,1.5 0 0,1 12,7M5.5,8A2.5,2.5 0 0,0 3,10.5C3,11.44 3.53,12.25 4.29,12.68C4.65,12.88 5.06,13 5.5,13C5.94,13 6.35,12.88 6.71,12.68C7.08,12.47 7.39,12.17 7.62,11.81C6.89,10.86 6.5,9.7 6.5,8.5C6.5,8.41 6.5,8.31 6.5,8.22C6.2,8.08 5.86,8 5.5,8M18.5,8C18.14,8 17.8,8.08 17.5,8.22C17.5,8.31 17.5,8.41 17.5,8.5C17.5,9.7 17.11,10.86 16.38,11.81C16.5,12 16.63,12.15 16.78,12.3C16.94,12.45 17.1,12.58 17.29,12.68C17.65,12.88 18.06,13 18.5,13C18.94,13 19.35,12.88 19.71,12.68C20.47,12.25 21,11.44 21,10.5A2.5,2.5 0 0,0 18.5,8M12,14C9.66,14 5,15.17 5,17.5V19H19V17.5C19,15.17 14.34,14 12,14M4.71,14.55C2.78,14.78 0,15.76 0,17.5V19H3V17.07C3,16.06 3.69,15.22 4.71,14.55M19.29,14.55C20.31,15.22 21,16.06 21,17.07V19H24V17.5C24,15.76 21.22,14.78 19.29,14.55M12,16C13.53,16 15.24,16.5 16.23,17H7.77C8.76,16.5 10.47,16 12,16Z" />
                              </svg>
                              &nbsp;&nbsp;Shared with me
                            </li>
                            <li data-text="Shared by me">
                              <svg style="width:20px;height:20px" viewBox="0 0 24 24">
                                <path fill="#999" d="M21,12L14,5V9C7,10 4,15 3,20C5.5,16.5 9,14.9 14,14.9V19L21,12Z" />
                              </svg>
                              &nbsp;&nbsp;Shared by me
                            </li>
                            <template
                              v-if="filelocation == 'Group Folder' || filelocation == 'Public' || filelocation == 'Any'">
                              <li data-text="Owned by others">
                                <svg style="width:20px;height:20px" viewBox="0 0 24 24">
                                  <path fill="#999"
                                    d="M12,5A3.5,3.5 0 0,0 8.5,8.5A3.5,3.5 0 0,0 12,12A3.5,3.5 0 0,0 15.5,8.5A3.5,3.5 0 0,0 12,5M12,7A1.5,1.5 0 0,1 13.5,8.5A1.5,1.5 0 0,1 12,10A1.5,1.5 0 0,1 10.5,8.5A1.5,1.5 0 0,1 12,7M5.5,8A2.5,2.5 0 0,0 3,10.5C3,11.44 3.53,12.25 4.29,12.68C4.65,12.88 5.06,13 5.5,13C5.94,13 6.35,12.88 6.71,12.68C7.08,12.47 7.39,12.17 7.62,11.81C6.89,10.86 6.5,9.7 6.5,8.5C6.5,8.41 6.5,8.31 6.5,8.22C6.2,8.08 5.86,8 5.5,8M18.5,8C18.14,8 17.8,8.08 17.5,8.22C17.5,8.31 17.5,8.41 17.5,8.5C17.5,9.7 17.11,10.86 16.38,11.81C16.5,12 16.63,12.15 16.78,12.3C16.94,12.45 17.1,12.58 17.29,12.68C17.65,12.88 18.06,13 18.5,13C18.94,13 19.35,12.88 19.71,12.68C20.47,12.25 21,11.44 21,10.5A2.5,2.5 0 0,0 18.5,8M12,14C9.66,14 5,15.17 5,17.5V19H19V17.5C19,15.17 14.34,14 12,14M4.71,14.55C2.78,14.78 0,15.76 0,17.5V19H3V17.07C3,16.06 3.69,15.22 4.71,14.55M19.29,14.55C20.31,15.22 21,16.06 21,17.07V19H24V17.5C24,15.76 21.22,14.78 19.29,14.55M12,16C13.53,16 15.24,16.5 16.23,17H7.77C8.76,16.5 10.47,16 12,16Z" />
                                </svg>
                                &nbsp;&nbsp;Owned by others
                              </li>
                            </template>
                          </ul>
                        </div>
                      </div>
                      <div class="row my-3">
                        <div class="col-md-4 col-sm-12 d-flex align-items-center">
                          <label class="m-0">Date Modified</label>
                        </div>
                        <div class="col-md-8 col-sm-12" v-click-outside="hide_date">
                          <span class="d-flex justify-content-between align-items-center in-field" @click="showdate">
                            <span>{{ filedate }}</span>
                            <span>
                              <img src="@/assets/search-icons/chevron-down.svg" />
                            </span>
                          </span>
                          <div class="mix">
                            <p class="m-0">
                            <ul class="menu" v-if="select_date" @click="selectdate">
                              <li data-text="Today"> &nbsp;&nbsp;Today</li>
                              <li data-text="Yesterday"> &nbsp;&nbsp;Yesterday</li>
                              <li data-text="Last 7 Days"> &nbsp;&nbsp;Last 7 Days</li>
                              <li data-text="Last 30 Days"> &nbsp;&nbsp;Last 30 Days</li>
                              <li data-text="Last 90 Days"> &nbsp;&nbsp;Last 90 Days</li>
                              <li data-text="Custom Date"> &nbsp;&nbsp;Custom Date</li>
                            </ul>
                            </p>
                            <p class="custom-date m-0 mt-2 d-flex" v-if="filedate === 'Custom Date'"
                              style="margin-bottom:0;">
                              <span class="mr-1">
                                <date-picker v-model="start_date" :lang="lang"></date-picker>
                              </span>
                              <span class="ml-1">
                                <date-picker v-model="end_date" :lang="lang"></date-picker>
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="row my-3"
                        v-if="fileowner === 'Owned by me' || fileowner === 'Owned by others' || fileowner === 'Select owner of file'">
                        <div class="col-md-4 col-sm-12 d-flex align-items-center">
                          <label class="m-0">File Location</label>
                        </div>
                        <div class="col-md-8 col-sm-12" v-click-outside="hide_filelocation">
                          <span class="d-flex justify-content-between align-items-center in-field"
                            @click="selectfilelocation">
                            <span>{{ filelocation }}</span>
                            <span>
                              <img src="@/assets/search-icons/chevron-down.svg" :class="{ 'rotate-90': file_owner }" />
                            </span>
                          </span>
                          <ul class="menu" v-if="file_location" @click="select_filelocation">
                            <li data-text="Any">
                              <svg style="width:18px;height:18px" viewBox="0 0 24 24">
                                <path fill="#999"
                                  d="M10,17L6.5,13.5L7.91,12.08L10,14.17L15.18,9L16.59,10.41M19.35,10.03C18.67,6.59 15.64,4 12,4C9.11,4 6.6,5.64 5.35,8.03C2.34,8.36 0,10.9 0,14A6,6 0 0,0 6,20H19A5,5 0 0,0 24,15C24,12.36 21.95,10.22 19.35,10.03Z" />
                              </svg>
                              &nbsp;&nbsp;Any
                            </li>
                            <li data-text="My Space">
                              <svg style="width:18px;height:18px" viewBox="0 0 16 16">
                                <path fill="#999"
                                  d="M4,1H20A1,1 0 0,1 21,2V6A1,1 0 0,1 20,7H4A1,1 0 0,1 3,6V2A1,1 0 0,1 4,1M4,9H20A1,1 0 0,1 21,10V14A1,1 0 0,1 20,15H4A1,1 0 0,1 3,14V10A1,1 0 0,1 4,9M4,17H20A1,1 0 0,1 21,18V22A1,1 0 0,1 20,23H4A1,1 0 0,1 3,22V18A1,1 0 0,1 4,17M9,5H10V3H9V5M9,13H10V11H9V13M9,21H10V19H9V21M5,3V5H7V3H5M5,11V13H7V11H5M5,19V21H7V19H5Z" />
                              </svg>
                              &nbsp;&nbsp;My Drive
                            </li>
                            <li data-text="Group Folder">
                              <svg style="width:20px;height:20px" viewBox="0 0 24 24">
                                <path fill="#999"
                                  d="M12,5A3.5,3.5 0 0,0 8.5,8.5A3.5,3.5 0 0,0 12,12A3.5,3.5 0 0,0 15.5,8.5A3.5,3.5 0 0,0 12,5M12,7A1.5,1.5 0 0,1 13.5,8.5A1.5,1.5 0 0,1 12,10A1.5,1.5 0 0,1 10.5,8.5A1.5,1.5 0 0,1 12,7M5.5,8A2.5,2.5 0 0,0 3,10.5C3,11.44 3.53,12.25 4.29,12.68C4.65,12.88 5.06,13 5.5,13C5.94,13 6.35,12.88 6.71,12.68C7.08,12.47 7.39,12.17 7.62,11.81C6.89,10.86 6.5,9.7 6.5,8.5C6.5,8.41 6.5,8.31 6.5,8.22C6.2,8.08 5.86,8 5.5,8M18.5,8C18.14,8 17.8,8.08 17.5,8.22C17.5,8.31 17.5,8.41 17.5,8.5C17.5,9.7 17.11,10.86 16.38,11.81C16.5,12 16.63,12.15 16.78,12.3C16.94,12.45 17.1,12.58 17.29,12.68C17.65,12.88 18.06,13 18.5,13C18.94,13 19.35,12.88 19.71,12.68C20.47,12.25 21,11.44 21,10.5A2.5,2.5 0 0,0 18.5,8M12,14C9.66,14 5,15.17 5,17.5V19H19V17.5C19,15.17 14.34,14 12,14M4.71,14.55C2.78,14.78 0,15.76 0,17.5V19H3V17.07C3,16.06 3.69,15.22 4.71,14.55M19.29,14.55C20.31,15.22 21,16.06 21,17.07V19H24V17.5C24,15.76 21.22,14.78 19.29,14.55M12,16C13.53,16 15.24,16.5 16.23,17H7.77C8.76,16.5 10.47,16 12,16Z" />
                              </svg>
                              &nbsp;&nbsp;Group Folder
                            </li>
                            <li data-text="Project Folder">
                              <svg style="width:20px;height:20px" viewBox="0 0 24 24">
                                <path fill="#999"
                                  d="M12,5A3.5,3.5 0 0,0 8.5,8.5A3.5,3.5 0 0,0 12,12A3.5,3.5 0 0,0 15.5,8.5A3.5,3.5 0 0,0 12,5M12,7A1.5,1.5 0 0,1 13.5,8.5A1.5,1.5 0 0,1 12,10A1.5,1.5 0 0,1 10.5,8.5A1.5,1.5 0 0,1 12,7M5.5,8A2.5,2.5 0 0,0 3,10.5C3,11.44 3.53,12.25 4.29,12.68C4.65,12.88 5.06,13 5.5,13C5.94,13 6.35,12.88 6.71,12.68C7.08,12.47 7.39,12.17 7.62,11.81C6.89,10.86 6.5,9.7 6.5,8.5C6.5,8.41 6.5,8.31 6.5,8.22C6.2,8.08 5.86,8 5.5,8M18.5,8C18.14,8 17.8,8.08 17.5,8.22C17.5,8.31 17.5,8.41 17.5,8.5C17.5,9.7 17.11,10.86 16.38,11.81C16.5,12 16.63,12.15 16.78,12.3C16.94,12.45 17.1,12.58 17.29,12.68C17.65,12.88 18.06,13 18.5,13C18.94,13 19.35,12.88 19.71,12.68C20.47,12.25 21,11.44 21,10.5A2.5,2.5 0 0,0 18.5,8M12,14C9.66,14 5,15.17 5,17.5V19H19V17.5C19,15.17 14.34,14 12,14M4.71,14.55C2.78,14.78 0,15.76 0,17.5V19H3V17.07C3,16.06 3.69,15.22 4.71,14.55M19.29,14.55C20.31,15.22 21,16.06 21,17.07V19H24V17.5C24,15.76 21.22,14.78 19.29,14.55M12,16C13.53,16 15.24,16.5 16.23,17H7.77C8.76,16.5 10.47,16 12,16Z" />
                              </svg>
                              &nbsp;&nbsp;Project Folder
                            </li>
                            <li data-text="Public">
                              <svg style="width:18px;height:18px" viewBox="0 0 24 24">
                                <path fill="#999"
                                  d="M17.9,17.39C17.64,16.59 16.89,16 16,16H15V13A1,1 0 0,0 14,12H8V10H10A1,1 0 0,0 11,9V7H13A2,2 0 0,0 15,5V4.59C17.93,5.77 20,8.64 20,12C20,14.08 19.2,15.97 17.9,17.39M11,19.93C7.05,19.44 4,16.08 4,12C4,11.38 4.08,10.78 4.21,10.21L9,15V16A2,2 0 0,0 11,18M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
                              </svg>
                              &nbsp;&nbsp;Public
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="row my-3">
                        <div class="col-md-12 col-sm-12 d-flex justify-content-end">
                          <span class="btn-reset" @click="resetsearch">
                            Reset
                          </span>&nbsp;&nbsp;&nbsp;
                          <span @click="makerequest" class="btn-search">
                            Search
                          </span>
                        </div>
                      </div>
                    </div>
                  </span>&nbsp;&nbsp;&nbsp;
                  <span style="cursor:pointer;" @click="refreshfolder">
                    <img src="@/assets/refresh.svg" />
                  </span>
                </div>
                <div class="col-4 pl-5 pr-0 d-flex justify-content-between align-items-center">
                  <span @click="toggleSearchActive" class="d-md-none"><svg width="20" height="20" viewBox="0 0 20 20"
                      fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M19.4082 17.7546L14.9977 13.3441C16.0596 11.9306 16.6328 10.2099 16.6308 8.44195C16.6308 3.92601 12.9568 0.251953 8.44085 0.251953C3.92492 0.251953 0.250854 3.92601 0.250854 8.44195C0.250854 12.9579 3.92492 16.6319 8.44085 16.6319C10.2088 16.6339 11.9295 16.0607 13.343 14.9988L17.7535 19.4093C17.9768 19.6089 18.268 19.7154 18.5673 19.707C18.8666 19.6986 19.1514 19.576 19.3631 19.3642C19.5749 19.1525 19.6975 18.8677 19.7059 18.5684C19.7143 18.2691 19.6078 17.9779 19.4082 17.7546ZM2.59085 8.44195C2.59085 7.28493 2.93395 6.15389 3.57676 5.19187C4.21956 4.22984 5.13321 3.48003 6.20216 3.03726C7.2711 2.59448 8.44734 2.47864 9.58213 2.70436C10.7169 2.93008 11.7593 3.48724 12.5774 4.30538C13.3956 5.12351 13.9527 6.16588 14.1784 7.30067C14.4042 8.43546 14.2883 9.6117 13.8455 10.6806C13.4028 11.7496 12.653 12.6632 11.6909 13.306C10.7289 13.9489 9.59787 14.2919 8.44085 14.2919C6.88991 14.2901 5.40302 13.6732 4.30633 12.5765C3.20965 11.4798 2.59271 9.9929 2.59085 8.44195Z"
                        fill="#677888" />
                    </svg>
                  </span>
                  <span style="position: relative">
                    <template v-if="$store.getters.canCreateFiles">
                      <span class="add-user-btn" @click="show_create_dropdown">
                        <span>
                          <PlusIcon />
                        </span>
                        <span class="d-none d-md-inline" style="font-size:14px;">New</span>
                      </span>
                    </template>
                    <template v-else>
                      <template v-if="$store.getters.canCreateFileInGroup || $store.getters.canCreateGroupFolder">
                        <span class="add-user-btn ml-3" @click="show_create_dropdown">
                          <span>
                            <PlusIcon />
                          </span>
                          <span class="d-none d-md-inline" style="font-size:14px;">New</span>
                        </span>
                      </template>
                    </template>
                    <div class="dropdown" v-if="create_dropdown" v-on-clickaway="hide" @click="close_drop">
                      <template v-if="$store.getters.canCreateFiles">
                        <ul>
                          <li @click="create_doc('folder')"><img src="@/assets/General.svg" /> &nbsp;&nbsp;Folders</li>
                          <li @click="create_doc('word')"><img src="@/assets/Doc.svg" /> &nbsp;&nbsp;Word Document</li>
                          <li @click="create_doc('sheets')"><img src="@/assets/XLS.svg"> &nbsp;&nbsp;Sheet Document</li>
                          <li @click="create_doc('powerpoint')"><img src="@/assets/PPT.svg" /> &nbsp;&nbsp;Presentation
                            Document</li>
                          <li @click="showbrowseuploadfolder('main')"><img src="@/assets/upload.svg" /> &nbsp;&nbsp;Upload
                            File</li>
                        </ul>
                      </template>
                      <template v-if="$store.getters.canCreateGroupFolder">
                        <ul>
                          <li @click="create_doc('group-folder')"><img src="@/assets/icons/folder/Group.svg" width="24px"
                              height="24px" /> &nbsp;&nbsp;Create Group Folder</li>
                        </ul>
                      </template>
                      <template v-if="$store.getters.canCreateFileInGroup">
                        <ul>
                          <li @click="create_doc('folder')"><img src="@/assets/General.svg" /> &nbsp;&nbsp;Folders</li>
                          <li @click="create_doc('word')"><img src="@/assets/Doc.svg" /> &nbsp;&nbsp;Word Document</li>
                          <li @click="create_doc('sheets')"><img src="@/assets/XLS.svg"> &nbsp;&nbsp;Sheet Document</li>
                          <li @click="create_doc('powerpoint')"><img src="@/assets/PPT.svg" /> &nbsp;&nbsp;Presentation
                            Document</li>
                          <li @click="showbrowseuploadfolder('main')"><img src="@/assets/upload.svg" /> &nbsp;&nbsp;Upload
                            File</li>
                        </ul>
                      </template>
                    </div>
                  </span>

                  <span>
                    <span class="viewtype" :class="{ 'active': viewtype == 'grid' }" @click="set_view_type('grid')">
                      <img src="@/assets/grid.svg" width="16px" height="16px" v-if="viewtype != 'grid'" />
                      <img src="@/assets/grid - blue.svg" width="16px" height="16px" v-if="viewtype == 'grid'" />
                    </span>
                    <span class="viewtype ml-3" :class="{ 'active': viewtype == 'list' }" @click="set_view_type('list')">
                      <img src="@/assets/List.svg" width="16px" height="16px" v-if="viewtype != 'list'" />
                      <img src="@/assets/List - Blue.svg" width="16px" height="16px" v-if="viewtype == 'list'" />
                    </span>
                  </span>
                </div>
              </div>
            </template>
            <template v-else>
              <header-option></header-option>
            </template>
            <div class="drive-files">
              <files ref="files"></files>
            </div>

            <div class="file-info" v-click-outside="closefileinfo2">
              <div class="file-container" :class="{ show: $store.getters.SHOW_FILE_INFO }">
                <div class="d-flex justify-content-between">
                  <h6><strong>File Info</strong></h6>
                  <span class="close_advanced_search" @click="closefileinfo">
                    <img src="@/assets/search-icons/Close.svg" />
                  </span>
                </div>
                <div>
                  <fileinfo :data="$store.getters.GET_FILE_INFO_DATA"></fileinfo>
                </div>
                <div class="comment_preview">
                  <viewcomments ref="commentpreview"></viewcomments>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <input type="file" ref="file" id="file" @change="upload" />
    </div>
    <browseuploadfolder ref="browseuploadfolder"></browseuploadfolder>
    <invite ref="invite"></invite>
    <upload ref="upload"></upload>
    <createfile ref="createfile"></createfile>
    <addfavourite ref="addfavourite"></addfavourite>
    <pinfile ref="pinfile"></pinfile>
    <unpinfile ref="unpinfile"></unpinfile>
    <removefavourite ref="removefavourite"></removefavourite>
    <updatecountry ref="updatecountry"></updatecountry>
    <updatephone ref="updatephone"></updatephone>
    <renamefile ref="renamefile"></renamefile>
    <addcomment ref="addcomment"></addcomment>
    <deleteprompt ref="deleteprompt"></deleteprompt>
    <permanent ref="permanent"></permanent>
    <cantcreate ref="cant_create"></cantcreate>
    <playvideo ref="playvideo"></playvideo>
    <playaudio ref="playaudio"></playaudio>
    <viewfile ref="viewfile"></viewfile>
    <viewtxt ref="viewtxt"></viewtxt>
    <edittxt ref="edittxt"></edittxt>
    <closeupload ref="closeupload"></closeupload>
    <startupload ref="startupload"></startupload>
    <groupaddfavourite ref="groupaddfavourite"></groupaddfavourite>
    <groupdelete ref="groupdelete"></groupdelete>
    <grouptrashdeleteprompt ref="grouptrashdeleteprompt"></grouptrashdeleteprompt>
    <grouptrash ref="grouptrash"></grouptrash>
    <grouppermanent ref="grouppermanent"></grouppermanent>
    <browsefolder ref="browsefolder"></browsefolder>
    <viewpdf ref="viewpdf"></viewpdf>
    <deletefilepermanently ref="deletefilepermanently"></deletefilepermanently>
    <copyfile ref="copyfile"></copyfile>
    <copytoexist ref="copytoexist"></copytoexist>
    <movefile ref="movefile"></movefile>
    <movetoexist ref="movetoexist"></movetoexist>
    <compressfile ref="compressfile"></compressfile>
    <compressexist ref="compressexist"></compressexist>
    <uncompressexist ref="uncompressexist"></uncompressexist>
    <trashdeleteprompt ref="trashdelete"></trashdeleteprompt>
    <restorefile ref="restorefile"></restorefile>
    <grouprestore ref="grouprestore"></grouprestore>
    <groupbrowsefolder ref="groupbrowsefolder"></groupbrowsefolder>
    <groupcopyfile ref="groupcopyfile"></groupcopyfile>
    <groupmovefile ref="groupmovefile"></groupmovefile>
    <groupcopytoexist ref="groupcopytoexist"></groupcopytoexist>
    <promptcompressrename ref="promptcompressrename"></promptcompressrename>
    <groupcompressexist ref="groupcompressexist"></groupcompressexist>
    <addusertofolder ref="addusertofolder"></addusertofolder>
    <editusertofolder ref="editusertofolder"></editusertofolder>
    <useraddedtofolder ref="useraddedtofolder"></useraddedtofolder>
    <uncompressfile ref="uncompressfile"></uncompressfile>
    <editcomment ref="editcomment"></editcomment>
    <comments ref="comments"></comments>
    <sharefile ref="sharefile"></sharefile>
    <editsharefileright ref="editsharefileright"></editsharefileright>
    <ShareableDialog ref="shareabledialog" />
    <trash ref="trash"></trash>
    <login ref="login"></login>
    <notify ref="notify"></notify>
    <search-file ref="searchfile"></search-file>
    <replycomment ref="replycomment"></replycomment>
    <loader ref="load"></loader>
    <splash ref="splash"></splash>
    <embeded ref="embed"></embeded>
    <dragmoveprompt ref="dragmoveprompt"></dragmoveprompt>
    <create-file-dialog ref="createfiledialog"></create-file-dialog>
    <removeupload ref="removeupload"></removeupload>
    <dragerror ref="dragerror"></dragerror>
    <logout ref="logout"></logout>
    <!--<audio autoplay="autoplay">
      <source src="../../media/just-saying.mp3" type="audio/mpeg">
    </audio>-->
  </div>
</template>
<style scoped>
input[type="file"] {
  display: none;
}

.grid-files .header {
  width: 100% !important;
}

.file-info {
  position: absolute;
  top: 0;
  height: 100%;
  right: -2rem;
}

.file-container {
  position: absolute;
  box-shadow: -10px 4px 13px rgba(209, 219, 228, 0.22);
  top: 0;
  height: 100%;
  background: #fff;
  padding: 1.2em;
  width: 24rem;
  right: -28rem;
  max-width: 100vw;
  transition: right 300ms ease-in;
}

.file-container.show {
  right: 0;
}

.drive-header {
  padding: 14px 30px;
  padding-left: 1.5rem;
  padding-right: 1rem;
  border-bottom: 1px solid #ced8e1;
  width: 100%;
  margin: 0;
}

.btn-reset {
  background: transparent;
  cursor: pointer;
  border-radius: 8px;
  width: 132px;
  height: 2.625rem;
  color: #3f96d1;
  border: 1px solid #3f96d1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}

.btn-search {
  background: #3f96d1;
  cursor: pointer;
  border-radius: 8px;
  width: 132px;
  height: 2.625rem;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}

.in-field {
  cursor: pointer;
  border-radius: 5px;
  border: 1px solid #a7b9cb;
  padding: 0.8em 0.6em;
  font-size: 13px;
}

.inp-field {
  border-radius: 5px;
  border: 1px solid #a7b9cb;
  padding: 0.8em 0.6em;
  width: 100%;
  font-size: 13px;
}

.rotate-90 {
  transform: rotate(-180deg);
}

.search-advanced-dropdown h6 {
  font-size: 18px;
  margin-bottom: 0;
  font-weight: 600;
  color: #000000;
}

.dropdown {
  background: #fff;
  border-radius: 4px;
  box-shadow: 0px 5px 44px rgba(178, 189, 211, 0.24);
  position: absolute;
  font-size: 15px;
  margin-top: 0.2em;
  padding: 0;
  text-align: left;
  z-index: 1000;
  right: 0;
}

.close_advanced_search {
  background: #f2f7fc;
  display: inline-flex;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.search-advanced-dropdown {
  background: #fff;
  border-radius: 4px;
  box-shadow: 0px 5px 44px rgba(178, 189, 211, 0.24);
  position: absolute;
  font-size: 15px;
  margin-top: 0.5em;
  padding: 0;
  text-align: left;
  z-index: 1000;
  right: 0;
  width: 100% !important;
  padding: 0.8em 1em;
}

.advanced-search-dropdown {
  background: #fff;
  border-radius: 4px;
  box-shadow: 0px 5px 44px rgba(178, 189, 211, 0.24);
  position: absolute;
  font-size: 15px;
  margin-top: 0.5em;
  padding: 0;
  text-align: left;
  z-index: 1000;
  right: 0;
  width: 100% !important;
}

.advanced-search-dropdown ul {
  width: auto !important;
  margin-bottom: 0;
}

.advanced-search-dropdown ul li {
  cursor: pointer;
  padding: 0.6em 1em;
  font-size: 14px;
}

.advanced-search-dropdown ul li:hover {
  background: #f9f9f9;
}

.menu {
  background: #fff;
  border-radius: 4px;
  box-shadow: 0px 3px 44px rgba(178, 189, 211, 0.24);
  position: absolute;
  font-size: 15px;
  margin-top: 0.5em;
  padding: 0;
  text-align: left;
  z-index: 1000;
  right: 0;
  width: 100% !important;
}

.menu {
  margin-bottom: 0;
}

.menu li {
  cursor: pointer;
  padding: 0.6em 1em;
  font-size: 14px;
}

.menu li:hover {
  background: #f9f9f9;
}

.search-dropdown {
  background: #fff;
  border-radius: 4px;
  box-shadow: 0px 5px 44px rgba(178, 189, 211, 0.24);
  position: absolute;
  font-size: 15px;
  margin-top: 0.5em;
  padding: 0;
  text-align: left;
  z-index: 1000;
  right: 0;
  width: 100% !important;
}

.search-dropdown ul {
  width: auto !important;
  margin-bottom: 0;
}

.search-dropdown ul li {
  cursor: pointer;
  padding: 0.8em 1em;
}

.search-dropdown ul li:hover {
  background: #f9f9f9;
}

.dropdown ul {
  width: 240px;
  margin-bottom: 0;
}

.dropdown ul li {
  cursor: pointer;
  padding: 0.8em 1em;
}

.dropdown ul li:hover {
  background: #f9f9f9;
}

.header .top .section .menu .create-new .dropdown ul li.line-div {
  background: #f1f1f1;
  height: 1px;
  padding: 0 !important;
}

.drive-header {
  padding: 1rem;
}

.top-navbar {
  height: calc(100% - 2rem) !important;
  padding: 0 !important;

  border-radius: 0.25rem;
}

.viewtype {
  background-color: #e5f2fc;
  box-sizing: border-box;
  border-radius: 6px;
  padding: 7px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 2.75rem;
  height: 2.75rem;
}

.serach-user-box {
  width: 447px !important;
  padding-left: 40px;
}

.search-bar-icon {
  left: 14px !important;
  right: auto !important;
}

.filter-icon-p {
  position: absolute;
  top: 7.6px;
  right: 14px;
  background: #ced8e1;
  border-radius: 50%;
  padding: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.filter-icon {
  position: absolute;
  top: 10px;
  right: 20px;
  cursor: pointer;
}

.add-user-btn {
  display: inline-flex !important;
  border: 1px solid #3f96d1 !important;
  color: #3f96d1 !important;
  background: #fff !important;
  gap: 1rem;
}

.canvas {
  width: 100%;
  height: 100%;
  right: 0;
  position: fixed;
  box-shadow: rgba(0, 0, 0, 0.22) 0px 25.6px 57.6px 0px,
    rgba(0, 0, 0, 0.18) 0px 4.8px 14.4px 0px;
}

.headerbox {
  display: flex;
  align-items: center;
  background: #f9f9fa;
  border-bottom: 1px solid #edf2f7;
  height: 3rem;
  padding-left: 12px;
}

.w-full {
  width: 100%;
}

.h-full {
  height: 100%;
}

.close-search {
  display: none;
}

@media only screen and (max-width: 960px) {
  .top-navbar {
    height: 100% !important;
  }

  .serach-user-box {
    /* width: 1rem !important; */
  }

  .col-6 {
    display: none !important;
  }

  .col-6.active {
    all: unset;
    position: absolute;
    width: calc(100% - 2rem);
    background: #fff;
    z-index: 10;
    display: flex !important;
    justify-content: space-between;
  }

  .col-6.active .search-bar-icon {
    top: 0.5rem;
  }

  .col-6.active .user-search-icons {
    flex-grow: 1;
  }

  .col-6.active .serach-user-box {
    width: calc(85%) !important;
    flex-grow: 1;
    height: 2.5rem;
    display: flex;
    align-items: center;
    padding-top: 0.75rem;
    padding-left: 3rem;
  }

  .col-4 {
    padding: 0 !important;
  }

  .viewtype {
    background: #fff;
    border: none;
    padding: 0 !important;
    height: unset;
    width: unset;
    line-height: 0;
  }

  .viewtype img {
    width: 1.5rem;
    height: 1.5rem;
  }

  .viewtype.ml-3 {
    margin: 0 !important;
  }

  .viewtype.active {
    display: none;
  }

  .add-user-btn {
    width: 1.5rem;
    height: 1.5rem;
    background: #3f96d1 !important;
    color: #fff !important;
    border-radius: 0.25rem !important;
  }

  .drive-header {
    justify-content: space-between;
  }

  .drive-header .col-2 {
    all: unset;
    flex-grow: 1;
    max-width: 10rem;
  }

  .drive-header .col-4 {
    all: unset;
    width: fit-content;
    gap: 1rem;
    line-height: 0;
  }

  .search-advanced-dropdown {
    width: 100vw !important;
    left: -1rem;
    margin-top: 1.1rem;
  }

  .close-search {
    position: absolute;
    display: inline;
    right: 4rem;
    top: 0.65rem;
  }

  .filter-icon-p {
    top: 0.25rem;
  }

  .file-container.show {
    right: 2rem;
  }
}
</style>
<script>
// @ is an alias to /src
import TopHeader from "@/components/Top-Header";
import sidebar from "@/components/Sidebar";
import files from "@/components/Files";
import upload from "@/components/Upload";
import createfile from "@/components/CreateFile";
import fileinfo from "@/components/FileInfo";
import viewcomments from "@/components/View-Comments";
import comments from "@/components/Comments";
import addfavourite from "@/components/Add-Favourite";
import pinfile from "@/components/Pin-File";
import unpinfile from "@/components/Unpin-File";
import removefavourite from "@/components/Remove-Favourite";
import renamefile from "@/components/Rename-File";
import { mapMutations } from "vuex";
import login from "@/components/Login";
import updatephone from "@/components/Update-Phone";
import updatecountry from "@/components/Update-Country";
import addcomment from "@/components/Add-Comment";
import deleteprompt from "@/components/Delete-Prompt";
import trashdeleteprompt from "@/components/Trash-Delete-Prompt";
import grouptrashdeleteprompt from "@/components/Group-Trash-Delete-Prompt";
import grouprestore from "@/components/Group-Restore";
import permanent from "@/components/Permanent";
import trash from "@/components/Trash";
import grouppermanent from "@/components/Group-Permanent";
import grouptrash from "@/components/Group-Trash";
import cantcreate from "@/components/CantCreate";
import playvideo from "@/components/Play-Video";
import playaudio from "@/components/Play-Audio";
import viewfile from "@/components/View-File";
import viewtxt from "@/components/View-Txt";
import edittxt from "@/components/Edit-Txt";
import closeupload from "@/components/Close-Upload";
import removeupload from "@/components/Remove-Upload";
import deletefilepermanently from "@/components/DeleteFilePermanently";
import startupload from "@/components/Start-Upload";
import groupaddfavourite from "@/components/Group-Add-Favourite";
import groupdelete from "@/components/Group-Delete";
import browsefolder from "@/components/Browse-Folder";
import copyfile from "@/components/CopyFile";
import copytoexist from "@/components/CopyToExist";
import movefile from "@/components/MoveFile";
import compressfile from "@/components/Compress-File";
import compressexist from "@/components/Compress-Exist";
import uncompressexist from "@/components/Uncompress-Exist";
import groupcompressexist from "@/components/Group-Compress-Exist";
import promptcompressrename from "@/components/Prompt-Compress-Rename";
import restorefile from "@/components/Restore-File";
import movetoexist from "@/components/MoveToExist";
import viewpdf from "@/components/View-Pdf";
import groupbrowsefolder from "@/components/Group-Browse-Folder";
import groupcopyfile from "@/components/Group-Copy-File";
import groupmovefile from "@/components/Group-Move-File";
import groupcopytoexist from "@/components/Group-Copy-To-Exist";
import addusertofolder from "@/components/Add-User-To-Folder";
import editusertofolder from "@/components/Edit-User-To-Folder";
import uncompressfile from "@/components/Uncompress-File";
import {
  createGroupFolderObservers,
  approveGroupFolderObservers,
  sharedFileObservers,
  createInsideGroupFolderObservers,
  createFileObservers,
  copyFileObservers,
} from "@/Observers.js";
import useraddedtofolder from "@/components/User-Added-To-Folder";
import sharefile from "@/components/Share-File";
import notify from "@/components/Notify";
import SearchFile from "@/components/SearchFile";
import logout from "@/components/Logout";
import loader from "@/components/Loading";
import replycomment from "@/components/Reply-Comment";
import editcomment from "@/components/Edit-Comment";
import editsharefileright from "@/components/Edit-Share-File-Rights";
import headerbox from "@/components/Header-Box";
import cookies from "@/services/cookies";
import splash from "@/components/Splash-Screen";
import embeded from "@/components/Embed";
import invite from "@/components/Invite";
import browseuploadfolder from "@/components/Browse-Upload-Folder";
import dragmoveprompt from '@/components/Drag-Move-Prompt'
import { directive as onClickaway } from "vue-clickaway";
import ClickOutside from "vue-click-outside";
import DatePicker from "vue2-datepicker2";
import HeaderOption from "@/components/Header-Option";
import CreateFileDialog from "@/components/Create-File-Dialog";
import ShareableDialog from '@/components/Shareable-Dialog'
import PlusIcon from "@/components/Icons/PlusIcon";
import ListIcon from "@/components/Icons/ListIcon";
import dragerror from "@/components/DragError"
import { $bus } from "./../utils";

export default {
  name: "home",
  components: {
    HeaderOption,
    browseuploadfolder,
    editsharefileright,
    replycomment,
    TopHeader,
    sidebar,
    comments,
    editcomment,
    files,
    closeupload,
    upload,
    createfile,
    fileinfo,
    viewcomments,
    addfavourite,
    removefavourite,
    pinfile,
    unpinfile,
    renamefile,
    login,
    updatecountry,
    updatephone,
    addcomment,
    deleteprompt,
    trashdeleteprompt,
    permanent,
    dragmoveprompt,
    trash,
    cantcreate,
    playvideo,
    playaudio,
    viewfile,
    viewtxt,
    edittxt,
    deletefilepermanently,
    startupload,
    groupaddfavourite,
    groupdelete,
    grouppermanent,
    grouptrash,
    browsefolder,
    copyfile,
    copytoexist,
    movefile,
    movetoexist,
    compressfile,
    compressexist,
    grouptrashdeleteprompt,
    restorefile,
    viewpdf,
    grouprestore,
    groupbrowsefolder,
    groupcopyfile,
    groupcopytoexist,
    groupcompressexist,
    groupmovefile,
    promptcompressrename,
    addusertofolder,
    editusertofolder,
    uncompressfile,
    uncompressexist,
    useraddedtofolder,
    sharefile,
    notify,
    logout,
    SearchFile,
    loader,
    splash,
    invite,
    embeded,
    DatePicker,
    CreateFileDialog,
    removeupload,
    dragerror,
    ShareableDialog,
    PlusIcon,
    ListIcon,
  },
  data() {
    return {
      showFileNav: false,
      audiosrc: "",
      chat: false,
      firstname: localStorage.getItem("firstname"),
      lastname: localStorage.getItem("lastname"),
      department: localStorage.getItem("department"),
      position: localStorage.getItem("position"),
      account_type: localStorage.getItem("account_type"),
      // viewtype: this.$store.getters.VIEW_TYPE,
      id: localStorage.getItem("id"),
      file_actions: false,
      create_dropdown: false,
      sort_order: false,
      view_options: false,
      select_file: false,
      settings_dropdown: false,
      notification_dropdown: false,
      type_term: "",
      advance: false,
      doctype: false,
      file_owner: false,
      select_date: false,
      start_date: "",
      end_date: "",
      filetype: "Select file type",
      fileowner: "Owned by me",
      filedate: "Select date file was modified",
      filelocation: "My Drive",
      file_location: false,
      filename: "",
      post: false,
      show_min: false,
      lang: {
        type: "en",
      },
      env: process.env.NODE_ENV === "development" ? "local" : "prod",
      host: location.hostname,
      protocol: location.protocol,
      userdropdown: false,
      sub_dropdown: true,
      advanced_search: false,
      upload_directory_id: "",
      searchActive: false,
    };
  },
  computed: {
    src() {
      return process.env.VUE_APP_NODE_ENV === "development"
        ? "https://192.168.1.2:9009/embed"
        : "https://app.fexspace.com/embed";
    },
    showNewButton() {
      return this.$store.getters.showNewButton;
    },
    viewtype: {
      get: function () {
        return this.$store.getters.VIEW_TYPE;
      },
    },
  },
  /*watch: {
    stored_view_type(newVal, oldVal) {
      this.viewtype = newVal;
    },
  },*/
  methods: {
    dragError(file_name) {
      // console.log(file_name)
      // console.log('Dig')
      this.$refs.dragerror.load(file_name)
    },
    dragmoveprompt(folder, file) {
      this.$refs.dragmoveprompt.load(folder, file)
    },
    shareable_dialog() {
      this.$refs.shareabledialog.load()
    },
    handleDragOver(e) {
      e.preventDefault();
      // $bus.emit("showDrop", true);
    },
    toggleSearchActive() {
      this.searchActive = !this.searchActive;
    },
    hide_search_active() {
      this.searchActive = false;
    },
    toggleFileNav() {
      this.showFileNav = !this.showFileNav;
    },
    fileExt(type) {
      if (type == "PDFs") {
        return "PDF";
      } else if (type == "Word Document") {
        return "Word Document";
      } else if (type == "Sheet Document") {
        return "Sheets Document";
      } else if (type == "Presentation Document") {
        return "Presentation Document";
      } else if (type == "Images") {
        return "Images";
      } else if (type == "Text File") {
        return "Text File";
      } else if (type == "Audio") {
        return "Audios";
      } else if (type == "Video") {
        return "Videos";
      } else if (type == "Compressed File") {
        return "Compressed File";
      } else if (type == "Folders") {
        return "Folders";
      }
    },
    makerequest() {
      this.advanced_search = false;

      let term = "";

      if (
        this.filetype !== "" ||
        this.fileowner !== "" ||
        this.filename !== "" ||
        this.filedate !== "" ||
        this.filelocation !== ""
      ) {
        this.searchfile();

        if (
          this.fileowner === "Shared by me" ||
          this.fileowner === "Shared with me"
        ) {
          this.filelocation = "";
        }

        if (
          this.fileowner === "Owned by others" &&
          this.filelocation != "Group Folder" &&
          this.filelocation != "Public" &&
          this.filelocation != "Project Folder"
        ) {
          this.filelocation = "";
        }

        let data = {
          token: cookies.getCookie("token"),
          type: this.filetype,
          owner: this.fileowner,
          name: this.filename,
          date: this.filedate,
          start_date: this.start_date,
          end_date: this.end_date,
          file_location: this.filelocation,
          method: "filter",
        };

        let that = this;

        this.$socket.emit("findfile", data, function (data) {
          if (data.data === true) {
            that.closesearch();
            that.SET_DIRECTORY_CHILDREN(data.directory_children);
            that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
            that.SORT_DIRECTORY_CHILDREN();
            that.SET_PATH(data.dir_path);
            that.SET_CURRENT_DIRECTORY("Search Results");
          }

          if (data.data === false) {
            that.closesearch();
            that.logincall();
            that.$router.push('/login')
          }
        });
      }
    },
    str_text(str) {
      if (str.length > 24) {
        return str.substring(0, 20) + "...";
      }
      return str;
    },
    create_doc(type) {
      if (this.$store.getters.ISTRIAL) {
        if (!this.$store.getters.TRIAL_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.notifyexpiration(
              "Your trial period has expired. Please contact your admin"
            );
            return;
          } else {
            this.notifyexpiration(
              'Your trial period has expired. <a href="/payments-billing">Payments & Billing</>'
            );
            return;
          }
        }
      } else {
        if (!this.$store.getters.PLAN_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.notifyexpiration(
              "Your trial period has expired. Please contact your admin"
            );
            return;
          } else {
            this.notifyexpiration(
              'Your trial period has expired. <a href="/payments-billing">Payments & Billing</>'
            );
            return;
          }
        }
      }

      if (this.$store.getters.GET_CURRENT_DIRECTORY == "Trash") {
        this.cant_create(this.$store.getters.GET_CURRENT_DIRECTORY);
      } else {
        this.create(type);
      }
    },
    create_file_dialog(parent_id, name, db, is_folder) {
      this.$refs.createfiledialog.load(parent_id, name, db, is_folder);
    },
    refreshfolder(show_loader = true) {
      if (show_loader) this.loading(true);
      let data = {
        token: cookies.getCookie("token"),
        current_directory_id: localStorage.getItem("current_directory_id"),
        db: localStorage.getItem("db"),
        filepath: sessionStorage.getItem("filepath"),
      };

      let that = this;

      this.$socket.emit("refresh", data, function (data) {
        if (data.data === true) {
          that.SET_DIRECTORY_CHILDREN(data.directory_children);
          that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
          that.SET_PATH(data.dir_path);
          that.SORT_DIRECTORY_CHILDREN();
          that.loading_close();
        }

        if (data.data === false) {
          that.$parent.loading_close();
          that.logincall();
          that.$router.push('/login')
        }
      });
    },
    resetsearch() {
      this.advanced_search = false;
      this.filetype = "Select file type";
      this.fileowner = "Owned by me";
      this.filedate = "Select date file was modified";
      this.filelocation = "My Drive";
      this.start_date = "";
      this.end_date = "";
    },
    hide_date() {
      this.select_date = false;
      // this.filedate = "Select date file was modified";
    },
    hide_filelocation() {
      this.file_location = false;
    },
    hide_owner() {
      this.file_owner = false;
    },
    hide_doctype() {
      if (this.doctype) this.doctype = false;
      // this.doctype = false
    },
    showtype() {
      this.doctype = !this.doctype;
      this.select_date = false;
      this.file_owner = false;
    },
    closesearch() {
      this.closesearchfile();
    },
    typeterm(evt) {
      this.select_file = false;

      if (evt.keyCode === 13 || evt.which === 13) {
        let term = evt.target.value;

        this.searchfile();
        let data = {
          token: cookies.getCookie("token"),
          term: term,
          method: "text",
        };

        let that = this;
        // console.log(data);

        this.$socket.emit("findfile", data, function (data) {
          if (data.data === true) {
            that.closesearch();
            that.SET_DIRECTORY_CHILDREN(data.directory_children);
            that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
            that.SORT_DIRECTORY_CHILDREN();
            that.SET_PATH(data.dir_path);
            that.SET_CURRENT_DIRECTORY("Search Results");
          }

          if (data.data === false) {
            that.closesearch();
            that.logincall();
            that.$router.login('/login')
          }
        });
      }
    },
    select_fileowner(evt) {
      if (evt.target.nodeName === "LI") {
        this.fileowner = evt.target.getAttribute("data-text");
        if (
          evt.target.getAttribute("data-text") == "Shared with me" ||
          evt.target.getAttribute("data-text") == "Shared by me"
        ) {
          this.filelocation = "";
        } else {
          this.filelocation = "My Drive";
        }
        this.file_owner = false;
      }
    },
    select_filetype(evt) {
      if (evt.target.nodeName === "LI") {
        this.filetype = evt.target.getAttribute("data-text");
        this.doctype = false;
      }
    },
    selectdate(evt) {
      if (evt.target.nodeName === "LI") {
        // console.log(evt.target.getAttribute("data-text"));
        this.filedate = evt.target.getAttribute("data-text");
        // console.log(this.filedate);
        this.select_date = false;

        if (this.filedate !== "Custom Date") {
          this.start_date = "";
          this.end_date = "";
        }
      }
    },
    showdate() {
      this.select_date = !this.select_date;
      this.file_owner = false;
      this.doctype = false;
      this.file_location = false;
    },
    showowner() {
      this.file_owner = !this.file_owner;
      this.select_date = false;
      this.doctype = false;
      this.file_location = false;
    },
    selectfilelocation() {
      this.file_location = !this.file_location;
      this.file_owner = false;
      this.select_date = false;
      this.doctype = false;
    },
    select_filelocation(evt) {
      if (evt.target.nodeName === "LI") {
        this.filelocation = evt.target.getAttribute("data-text");
        this.file_location = false;
      }
    },
    close_advanced_search() {
      this.advanced_search = false;
    },
    hide_advanced_search() {
      this.advanced_search = false;
      this.filetype = "Select file type";
      this.fileowner = "Owned by me";
      this.filedate = "Select date file was modified";
      this.filelocation = "My Drive";
      this.start_date = "";
      this.end_date = "";
    },
    show_advanced_search() {
      this.advanced_search = true;
    },
    showbrowseuploadfolder(src) {
      if (src == "main") {
        this.trigger(localStorage.getItem("current_directory_id"));
        return;
      }

      this.$refs.browseuploadfolder.load(src);
    },
    close_select_file() {
      this.select_file = false;
    },
    closelistdown(e) {
      let term = "";
      let filetype = "";

      if (e.target.nodeName === "LI" || e.target.nodeName === "I") {
        this.listdown = false;
      }

      if (e.target.nodeName === "LI") {
        this.type_term = "type:" + e.target.innerText.trim();
        term = e.target.innerText.trim();
      }

      if (e.target.nodeName === "I") {
        this.type_term = "type:" + e.target.parentNode.innerText.trim();
        term = e.target.parentNode.innerText.trim();
      }

      if (term != "") {
        this.searchfile();
        let data = {
          token: cookies.getCookie("token"),
          term: term,
          type: this.fileExt(term),
          method: "type",
        };

        let that = this;
        console.log(data);

        this.$socket.emit("findfile", data, function (data) {
          if (data.data === true) {
            that.closesearch();
            that.SET_DIRECTORY_CHILDREN(data.directory_children);
            that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
            that.SORT_DIRECTORY_CHILDREN();
            that.SET_PATH(data.dir_path);
            that.SET_CURRENT_DIRECTORY("Search Results");
          }

          if (data.data === false) {
            that.closesearch();
            that.logincall();
            that.$router.push('/login')
          }
        });
      }
    },
    show_select_file() {
      this.type_term = "";
      if (!this.select_file) {
        this.select_file = true;
      }
    },
    hide_select_file() {
      this.select_file = false;
    },
    hide() {
      this.create_dropdown = false;
      this.sort_order = false;
      this.view_options = false;
      this.select_file = false;
      this.settings_dropdown = false;
      this.notification_dropdown = false;
      this.advanced_search = false;
      this.show_min = false;
      this.doctype = false;
      this.userdropdown = false;
      this.sub_dropdown = false;
    },
    trigger(upload_directory_id) {
      this.upload_directory_id = upload_directory_id;
      if (this.$store.getters.ISTRIAL) {
        if (!this.$store.getters.TRIAL_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.$parent.notifyexpiration(
              "Your trial period has expired. Please contact your admin"
            );
            return;
          } else {
            this.$parent.notifyexpiration(
              'Your trial period has expired. <a href="/payments-billing">Payments & Billing</a>'
            );
            return;
          }
        }
      } else {
        if (!this.$store.getters.PLAN_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.$parent.notifyexpiration(
              "Your trial period has expired. Please contact your admin"
            );
            return;
          } else {
            this.$parent.notifyexpiration(
              'Your trial period has expired. <a href="/payments-billing">Payments & Billing</a>'
            );
            return;
          }
        }
      }
      let up = document.querySelector("#file");
      up.click();
    },
    show_create_dropdown() {
      this.create_dropdown = !this.create_dropdown;
    },
    upload() {
      this.$refs.browseuploadfolder.closebox();
      this.$refs.upload.load(this.$refs.file.files, this.upload_directory_id);
      this.$refs.file.value = "";
    },
    drag_upload(files, directory_id) {
      this.$refs.upload.load(files, directory_id);
    },
    close_drop(e) {
      if (
        e.target.nodeName === "LI" ||
        e.target.nodeName === "I" ||
        e.target.nodeName === "IMG" ||
        e.target.nodeName === "svg" ||
        e.target.nodeName === "SPAN"
      ) {
        this.create_dropdown = false;
        this.sort_order = false;
        this.view_options = false;
      }
    },
    adduser() {
      // remover later
    },
    set_view_type(type) {
      localStorage.setItem('view_type', type)
      this.$refs.files.set_view_type(type);
    },
    getPhoto(photo) {
      const pt = `${this.backendUrl}/static-photos/${photo}`;
      return pt;
    },
    getInitials(name) {
      const nm = name.first;
      return nm.charAt(0);
    },
    notifyexpiration(text) {
      this.$refs.notify.load(text);
    },
    closebox() {
      if (this.$store.getters.SHOW_CHAT) {
        this.TOGGLE_CHAT();
      }

      if (this.$store.getters.SHOW_NOTE) {
        this.TOGGLE_NOTE();
      }

      if (this.$store.getters.SHOW_NOTIFICATION) {
        this.TOGGLE_NOTIFICATION();
      }
    },
    invite() {
      this.$refs.invite.load();
    },
    playsound() {
      let au = new Audio("@/assets/just-saying.mp3");
      au.play();
    },
    loading(click) {
      this.$refs.load.load(click);
    },
    loading_close() {
      this.$refs.load.close();
    },
    comments(fileId) {
      this.$refs.comments.load(fileId);
    },
    editcomment(name, data) {
      this.$refs.editcomment.load(name, data);
    },
    ...mapMutations([
      "SET_FILE_ACTION",
      "REMOVE_FILE_ACTION",
      "SET_DIRECTORY_CHILDREN",
      "TOGGLE_FILE_INFO",
      "TOGGLE_CHAT",
      "TOGGLE_NOTE",
      "TOGGLE_NOTIFICATION",
      "SORT_DIRECTORY_CHILDREN",
      "SORT_STORED_DIRECTORY_CHILDREN",
      "SET_STORED_DIRECTORY_CHILDREN",
      "GET_DIRECTORY_CHILDREN",
      "CLOSE_FILE_INFO",
      "SET_PATH",
      "UPDATE_SLIDEIN",
      "UPDATE_SLIDEOUT",
      "UPDATE_BODY_MENU",
      "UPDATE_MENU",
      "UPDATE_TOTAL_CREATED_IMAGES",
      "UPDATE_TOTAL_CREATED_DOCUMENTS",
      "UPDATE_TOTAL_CREATED_FOLDERS",
      "SET_FIRSTNAME",
      "SET_LASTNAME",
      "SET_EMAIL",
      "SET_PHONE",
      "SET_POSITION",
      "SET_DEPARTMENT",
      "SET_COUNTRY",
      "SET_DATE_CREATED",
      "SET_ACCT_TYPE",
      "SET_ISADMIN",
      "SET_PHOTO",
      "UPDATE_TOTAL_SPACE",
      "UPDATE_DEFAULT_FOLDER",
      "UPDATE_TOTAL_USED_SPACE",
      "SET_ISTRIAL",
      "SET_ISSTAFF",
      "SET_ISSUPERADMIN",
      "SET_PATH",
      "SORT_DIRECTORY_CHILDREN",
      "SET_CURRENT_DIRECTORY",
      "HIDE_FILE_INFO",
      "SET_FILE_ACTION",
      "SET_SELECT_ALL",
      "SET_DB",
      "UPDATE_DIRECTORY_CHILDREN",
      "UPDATE_USER",
      "SET_NAME",
      "SET_CAN_CREATE",
      "SET_CREATE_RIGHT",
      "SET_PRINT_RIGHT",
      "SET_CURRENT_PLAN",
      "EMPTY_FILES_INDEX",
      "ADD_NOTIFICATION",
      "UPDATE_NOTIFICATION_COUNT",
      "UPDATE_SHARED_WITH_ME_COUNT",
      "SORT_NOTIFICATION",
      "UPDATE_NOTIFICATION",
      "SET_PERSONAL_SCROLL",
      "SET_FULL_LINK",
      "SET_MIN_LINK",
      "SET_USER_PLAN",
      "UPDATE_PUBLIC_FOLDER_ID",
      "SET_IS_SECURITY_QUESTION",
      "SET_CREATE_RIGHT",
      "SET_EDIT_RIGHT",
      "SET_DOWNLOAD_RIGHT",
      "SET_PRINT_RIGHT",
      "SET_GROUP_CREATE_MODE",
      "SET_COMPANY",
      "SET_PLAN_STATUS",
      "SET_TRIAL_STATUS",
      "SET_REFERRAL_LINK",
      "SET_HAS_ON_BOARDED",
      "SET_RECENT_FILES",
      "SET_HAS_CRM",
      "SET_HAS_INVEX",
      "SET_INVEX_DOMAIN",
      "SET_INVEX_API_URL"
    ]),
    replycomment(comment) {
      this.$refs.replycomment.load(comment);
    },
    load() {
      this.$refs.load.load();
    },
    close_load() {
      this.$refs.load.close();
    },
    searchfile() {
      this.$refs.searchfile.load();
    },
    closesearchfile() {
      this.$refs.searchfile.close();
    },
    do_upload_cancel() {
      this.$refs.upload.cancel_uploads();
    },
    do_remove_upload(id) {
      this.$refs.upload.do_remove_upload(id);
    },
    back() {
      let data = {
        token: cookies.getCookie("token"),
      };

      let that = this;
      this.SET_FILE_ACTION("");

      this.$socket.emit("loadmainfiles", data, function (data) {
        if (data.data === true) {
          localStorage.setItem(
            "current_directory_id",
            data.current_directory_id
          );
          localStorage.setItem("current_directory", data.current_directory);
          localStorage.setItem("db", "filesystem");
          that.SET_DIRECTORY_CHILDREN(data.directory_children);
          that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
          that.SET_CURRENT_DIRECTORY(data.current_directory);
          that.SET_RECENT_FILES(data.recentFiles);
          that.SET_PATH([]);
          that.SORT_DIRECTORY_CHILDREN();
        }

        if (data.data === false) {
          that.logincall();
          sessionStorage.removeItem("status");
          that.$router.push('/login')
        }
      });
    },
    file_exist(
      index,
      copy_file_id = "",
      selected_folder_id = "",
      new_name,
      type
    ) {
      if (type == "copy") {
        this.$refs.copytoexist.loader(
          copy_file_id,
          selected_folder_id,
          new_name
        );
      }

      if (type == "move") {
        this.$refs.movetoexist.loader(
          index,
          copy_file_id,
          selected_folder_id,
          new_name
        );
      }

      if (type == "compress") {
        this.$refs.compressexist.loader(index, new_name);
      }

      if (type == "uncompress") {
        this.$refs.uncompressexist.loader(index, new_name);
      }
    },
    group_compress_file_exist(name, old_name, ids) {
      this.$refs.groupcompressexist.loader(name, old_name, ids);
    },
    group_file_exist(
      selected_folder_id = "",
      selected_folder_name,
      old_name,
      new_name,
      copy_files,
      current_file_id,
      type
    ) {
      if (type === "copy") {
        this.$refs.groupcopytoexist.loader(
          selected_folder_id,
          selected_folder_name,
          new_name,
          old_name,
          copy_files,
          current_file_id
        );
      }

      if (type === "move") {
      }
    },
    notify(text) {
      this.$refs.notify.load(text);
    },
    useradded() {
      this.$refs.useraddedtofolder.load();
    },
    addusertofolder(folder_id, folder_name, await_status) {
      this.$refs.addusertofolder.load(folder_id, folder_name, await_status);
    },
    editusertofolder(folder_id, folder_name) {
      this.$refs.editusertofolder.load(folder_id, folder_name);
    },
    copyfile(index, location_id, location, db, is_shared = false) {
      this.$refs.copyfile.load(index, location_id, location, db, is_shared);
    },
    movefile(index, location_id, location, db) {
      this.$refs.movefile.load(index, location_id, location, db);
    },
    groupcopyfile(location_id, location) {
      this.$refs.groupcopyfile.load(location_id, location);
    },
    groupmovefile(location_id, location) {
      this.$refs.groupmovefile.load(location_id, location);
    },
    promptcompressrename() {
      this.$refs.promptcompressrename.load();
    },
    compressfile(index, src) {
      this.$refs.compressfile.load(index, src);
    },
    uncompressfile(index) {
      this.$refs.uncompressfile.load(index);
    },
    view_file(index, id) {
      this.$refs.viewfile.load(index, id);
    },
    sharefile(index = null, is_group = false) {
      this.$refs.sharefile.load(index, is_group);
    },
    editsharefileright(data, index) {
      this.$refs.editsharefileright.load(data, index);
    },
    play_video(index, id) {
      this.$refs.playvideo.load(id);
    },
    play_audio(index, id) {
      this.$refs.playaudio.load(id);
    },
    close_upload(files) {
      this.$refs.closeupload.load(files);
    },
    remove_upload(id, name) {
      this.$refs.removeupload.load(id, name);
    },
    change_pic() {
      this.UPDATE_SLIDEIN(false);
      this.UPDATE_SLIDEOUT(true);
      this.UPDATE_MENU(false);
      this.UPDATE_BODY_MENU(false);

      this.$refs.pic.click();
    },
    group_add_to_favourite() {
      this.$refs.groupaddfavourite.add();
    },
    start_upload() {
      this.$refs.startupload.load(this.$refs.pic.files[0]);
      this.$refs.pic.value = "";
    },
    add_comment(name, id) {
      this.$refs.addcomment.load(name, id, true);
    },
    slideout($evt) {
      if ($evt.target.tagName === "svg" || $evt.target.tagName === "path") {
        this.UPDATE_SLIDEIN(false);
        this.UPDATE_SLIDEOUT(true);
        this.UPDATE_MENU(false);
        this.UPDATE_BODY_MENU(false);
      } else {
        if ($evt.target.classList.contains("menubody")) {
          this.UPDATE_SLIDEIN(false);
          this.UPDATE_SLIDEOUT(true);
          this.UPDATE_MENU(false);
          this.UPDATE_BODY_MENU(false);
        }
      }
    },
    viewpdf(id, rights = null) {
      this.$refs.viewpdf.load(id, rights);
    },
    view_txt(index, id) {
      this.$refs.viewtxt.load(index, id);
    },
    view_file_doc(id, right, db) {
      if (db === "group") {
        if (right === "edit") {
          let a = document.createElement("a");
          a.setAttribute(
            "href",
            process.env.VUE_APP_HTTP +
            "://" +
            location.host +
            "/group-edit-doc/" +
            id
          );
          a.setAttribute("target", "_blank");
          a.hidden = true;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        } else {
          let a = document.createElement("a");
          a.setAttribute(
            "href",
            process.env.VUE_APP_HTTP +
            "://" +
            location.host +
            "/group-view-doc/" +
            id
          );
          a.setAttribute("target", "_blank");
          a.hidden = true;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      }

      if (db === "filesystem") {
        let a = document.createElement("a");
        a.setAttribute(
          "href",
          process.env.VUE_APP_HTTP + "://" + location.host + "/edit-doc/" + id
        );
        a.setAttribute("target", "_blank");
        a.hidden = true;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }

      if (db === "public") {
        let a = document.createElement("a");
        a.setAttribute(
          "href",
          process.env.VUE_APP_HTTP +
          "://" +
          location.host +
          "/public-edit-doc/" +
          id
        );
        a.setAttribute("target", "_blank");
        a.hidden = true;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }

      if (db === "sharedwithme") {
        let a = document.createElement("a");
        if (right === "edit") {
          a.setAttribute(
            "href",
            process.env.VUE_APP_HTTP +
            "://" +
            location.host +
            "/shared-edit-doc/" +
            id
          );
        } else {
          a.setAttribute(
            "href",
            process.env.VUE_APP_HTTP +
            "://" +
            location.host +
            "/shared-view-doc/" +
            id
          );
        }
        a.setAttribute("target", "_blank");
        a.hidden = true;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    },
    edit_txt(index, id) {
      this.$refs.edittxt.load(index, id);
    },
    deletefilepermanently(index, prompt = "") {
      this.$refs.deletefilepermanently.load(index, prompt);
    },
    restorefile(index) {
      this.$refs.restorefile.load(index);
    },
    updatephone() {
      this.$refs.updatephone.load();
    },
    updatecountry() {
      this.$refs.updatecountry.load();
    },
    logincall() {
      this.$refs.login.load();
    },
    closefileinfo() {
      this.CLOSE_FILE_INFO();
    },
    closefileinfo2() {
      // console.log(this.$store.getters.SHOW_FILE_INFO)
      if (this.$store.getters.SHOW_FILE_INFO) {
        // this.CLOSE_FILE_INFO();
      }
    },
    cant_create(name) {
      this.$refs.cant_create.load(name);
    },
    create(type) {
      this.$refs.createfile.load(type);
    },
    loadCommentPreview(id) {
      this.$refs.commentpreview.load(id);
    },
    pinfile(index, id) {
      this.$refs.pinfile.pin(index, id);
    },
    unpinfile(index, id) {
      this.$refs.unpinfile.pin(index, id);
    },
    add_favourite(index, id) {
      this.$refs.addfavourite.add(index, id);
    },
    remove_favourite(index, id) {
      this.$refs.removefavourite.remove(index, id);
    },
    renamefile(index, name, id, base) {
      this.$refs.renamefile.rename(index, name, id, base);
    },
    copyto(index, is_shared = false) {
      this.$refs.browsefolder.load(index, "copy", is_shared);
    },
    moveto(index) {
      this.$refs.browsefolder.load(index, "move");
    },
    group_copyto() {
      this.$refs.groupbrowsefolder.load("copy");
    },
    group_moveto() {
      this.$refs.groupbrowsefolder.load("move");
    },
    group_delete() {
      this.$refs.groupdelete.load();
    },
    grouptrashdeleteprompt() {
      this.$refs.grouptrashdeleteprompt.load();
    },
    grouprestore() {
      this.$refs.grouprestore.load();
    },
    deletefile(index, id, src) {
      this.$refs.deleteprompt.load(index, id, src);
    },
    permanent(index, id, src) {
      this.$refs.permanent.load(index, id, src);
    },
    trash(index, id, src) {
      this.$refs.trash.load(index, id, src);
    },
    trashdeleteprompt(index, id) {
      this.$refs.trashdelete.load(index, id, "group");
    },
    grouppermanent(index, id) {
      this.$refs.grouppermanent.load();
    },
    grouptrash(index, id) {
      this.$refs.grouptrash.load();
    },
    onload() {
      let doc = document.querySelector("#eb-chat");
      doc.contentWindow.postMessage(cookies.getCookie("token"), "*");
    },
    user_data() {
      let data = {
        token: cookies.getCookie("token"),
      };

      let that = this;

      this.$socket.emit("get-data", data, function (data) {
        if (data.data === true) {
          that.SET_ACCT_TYPE(data.account_type);
          that.SET_ISADMIN(data.isSuperAdmin);
          that.SET_FIRSTNAME(data.firstname);
          that.SET_LASTNAME(data.lastname);
          that.SET_NAME(data.firstname + " " + data.lastname);
          that.SET_EMAIL(data.email);
          that.SET_PHONE(data.phone);
          that.SET_POSITION(data.position);
          that.SET_HAS_CRM(data.hasCrm);
          that.SET_HAS_INVEX(data.hasInvex);
          that.SET_INVEX_DOMAIN(data.invex_domain);
          that.SET_INVEX_API_URL(data.invex_api_url);
          that.SET_DEPARTMENT(data.department);
          that.SET_COMPANY(data.company);
          that.SET_COUNTRY(data.country ? data.country : "");
          that.SET_DATE_CREATED(data.date_created);
          that.SET_PHOTO(data.photo);
          that.UPDATE_TOTAL_SPACE(data.total_space);
          that.UPDATE_TOTAL_USED_SPACE(data.total_space_used);
          that.UPDATE_USER(data.id);
          that.SET_CURRENT_PLAN(data.current_plan);
          that.SET_USER_PLAN(data.user_plan);
          that.SET_PLAN_STATUS(data.isPlanActive);
          that.SET_TRIAL_STATUS(data.isTrialActive);
          that.SET_REFERRAL_LINK(
            process.env.VUE_APP_REFERRAL + data.referral_link
          );

          that.SET_HAS_ON_BOARDED(data.has_on_boarded);

          that.SET_ISTRIAL(data.isTrial);
          that.SET_ISSTAFF(data.isStaff);
          that.SET_ISSUPERADMIN(data.isSuperAdmin);

          that.SET_IS_SECURITY_QUESTION(data.is_security_question);

          that.UPDATE_DEFAULT_FOLDER(data.default_folders);

          that.UPDATE_PUBLIC_FOLDER_ID(data.public_folder_id);

          localStorage.setItem("email", data.email);
          localStorage.setItem("id", data.id);
          localStorage.setItem(
            "is_security_question",
            data.is_security_question
          );
          sessionStorage.setItem("gi", data.group_folder_id);
          sessionStorage.setItem("pi", data.project_folder_id);

          localStorage.setItem("page", data.page_name);
          localStorage.setItem("page_url", data.page_url);

          that.UPDATE_TOTAL_CREATED_IMAGES(data.total_created_images);
          that.UPDATE_TOTAL_CREATED_DOCUMENTS(data.total_created_documents);
          that.UPDATE_TOTAL_CREATED_FOLDERS(data.total_created_folders);
        } else {
          cookies.removeCookie('token')
          cookies.removeCookie('invextoken')
          that.$router.push('/login')

        }
      });
    },
    logout() {
      this.UPDATE_SLIDEIN(false);
      this.UPDATE_SLIDEOUT(true);
      this.UPDATE_MENU(false);
      this.UPDATE_BODY_MENU(false);
      this.$refs.logout.logout();
    },
  },
  created() {
    let that = this;
    window.addEventListener("resize", function () {
      if (window.innerWidth < 1200) {
        that.SET_FULL_LINK(false);
        that.SET_MIN_LINK(true);
      } else {
        that.SET_FULL_LINK(true);
        that.SET_MIN_LINK(false);
      }

      if (window.innerHeight < 680) {
        that.SET_PERSONAL_SCROLL(true);
      } else {
        that.SET_PERSONAL_SCROLL(false);
      }
    });
  },
  directives: {
    onClickaway: onClickaway,
    ClickOutside,
  },
  mounted() {
    let that = this;

    this.$refs.splash.load();

    // console.log(localStorage.getItem("current_directory"));

    this.SET_CURRENT_DIRECTORY(localStorage.getItem("current_directory"));

    if (this.$route.params.id) {
      if (this.$route.params.id == "shared-with-me") {
        let data = {
          token: cookies.getCookie("token"),
        };

        this.SET_FILE_ACTION("");
        this.HIDE_FILE_INFO();
        this.SET_SELECT_ALL(false);
        this.EMPTY_FILES_INDEX();

        let that = this;

        this.$socket.emit("get-shared-with", data, function (data) {
          if (data.data === true) {
            that.$refs.splash.close();
            localStorage.setItem("current_directory_id", "");
            localStorage.setItem("current_directory", "Shared With Me");
            localStorage.setItem("db", "sharedwithme");
            that.SET_DB("sharedwithme");
            that.SET_DIRECTORY_CHILDREN(data.directory_children);
            that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
            that.SET_CURRENT_DIRECTORY("Shared With Me");
            that.SET_PATH(data.dir_path);
            that.SORT_DIRECTORY_CHILDREN();
          }

          if (data.data === false) {
            that.$refs.splash.close();
            that.logincall();
            sessionStorage.removeItem("status");
            that.$router.push('/login')
          }
        });

        this.user_data();
        return;
      }

      if (
        this.$route.params.id !== "undefined" &&
        this.$route.params.id !== null &&
        this.$route.params.id !== "" &&
        this.$route.params.id !== undefined
      ) {
        let data = {
          token: cookies.getCookie("token"),
          id: this.$route.params.id,
        };

        this.$socket.emit("current-directory", data, function (data) {
          if (data.data === true) {
            that.$refs.splash.close();

            localStorage.setItem(
              "current_directory_id",
              data.current_directory_id
            );
            localStorage.setItem("current_directory", data.current_directory);
            that.SET_DB(localStorage.getItem("db"));
            that.SET_DIRECTORY_CHILDREN(data.directory_children);
            that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
            that.SORT_DIRECTORY_CHILDREN();

            if (data.group === "PERSONAL" || data.group === "PUBLIC") {
              if (data.group === "PERSONAL") {
                sessionStorage.setItem("db", "filesystem");
              }

              if (data.group === "PUBLIC") {
                sessionStorage.setItem("db", "public");
              }
              that.SET_DB(sessionStorage.getItem("db"));
              that.SET_CREATE_RIGHT(true);
              that.SET_CAN_CREATE(true);
              that.SET_EDIT_RIGHT(true);
              that.SET_DOWNLOAD_RIGHT(true);
              that.SET_PRINT_RIGHT(true);
            } else {
              sessionStorage.setItem("db", "group");
              if (
                (data.group === "GROUP" || data.group === "PROJECT") &&
                String(data.current_directory_id) ===
                String(sessionStorage.getItem("gi"))
              ) {
                sessionStorage.setItem("is_group", true);
                sessionStorage.setItem("create_mode", true);
                that.SET_GROUP_CREATE_MODE(
                  sessionStorage.getItem("create_mode")
                );
              } else {
                sessionStorage.setItem("group_create", data.create_right);
                sessionStorage.setItem("create", data.create_right);
                sessionStorage.removeItem("create_mode");
                sessionStorage.setItem("is_group", true);
                that.SET_GROUP_CREATE_MODE(false);
              }

              if (data.group === "GROUP" || data.group === "PROJECT") {
                that.SET_CREATE_RIGHT(sessionStorage.getItem("group_create"));
                that.SET_DB(sessionStorage.getItem("db"));
                that.SET_CAN_CREATE(sessionStorage.getItem("create"));
                that.SET_EDIT_RIGHT(data.edit_right);
                that.SET_DOWNLOAD_RIGHT(data.download_right);
                that.SET_PRINT_RIGHT(data.print_right);
              }
            }

            that.SET_PATH(data.dir_path);
          }

          if (data.data === false) {
            that.$router.push("/login");
            sessionStorage.removeItem("status");
          }
        });
      } else {
        let data = {
          token: cookies.getCookie("token"),
        };

        this.$socket.emit("eb:auth", data, function (data) {
          if (data.data === true) {
            that.$refs.splash.close();
            localStorage.setItem(
              "current_directory_id",
              data.current_directory_id
            );
            localStorage.setItem("current_directory", data.current_directory);
            localStorage.setItem("db", "filesystem");
            that.SET_DB("filesystem");
            that.SET_PATH([]);
            that.SET_DIRECTORY_CHILDREN(data.directory_children);
            that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
            that.SET_RECENT_FILES(data.recentFiles);
            that.SORT_DIRECTORY_CHILDREN();
          }

          if (data.data === false) {
            that.$router.push("/login");
            sessionStorage.removeItem("status");
          }
        });
      }

      copyFileObservers.subscribe((data) => {
        let items = Object.keys(that.$store.getters.GET_FILES_INDEX);
        delete that.$store.getters.GET_FILES_INDEX[data.id];

        if (data.type === "move") {
          let files = that.$store.getters.DIRECTORY_CHILDREN.filter((file) => {
            if (file.id !== data.id) {
              file.is_checked = false;
              return file;
            }
          });

          that.SET_DIRECTORY_CHILDREN(files);
          that.SET_STORED_DIRECTORY_CHILDREN(files);
          that.SORT_DIRECTORY_CHILDREN();
        }
      });

      sharedFileObservers.subscribe((data) => {
        if (data.who.includes(localStorage.getItem("id"))) {
          let dataText = {
            id: data.message.id,
            text: data.message.message,
            is_checked: data.message.is_checked,
            is_read: data.message.is_read,
            createdAt: data.message.createAt,
          };
          that.UPDATE_NOTIFICATION(dataText);
          let notification = that.$store.getters.NOTIFICATION;
          let countnote = notification.map((note) => {
            if (!note.is_checked.includes(localStorage.getItem("id"))) {
              return true;
            }
          });
          that.UPDATE_NOTIFICATION_COUNT(countnote.length);
          // that.SORT_NOTIFICATION()
          let count = that.$store.getters.SHARED_WITH_ME_COUNT;
          ++count;
          that.UPDATE_SHARED_WITH_ME_COUNT(count);
        }
      });

      createFileObservers.subscribe((data) => {
        let files = that.$store.getters.DIRECTORY_CHILDREN.map((file) => {
          return file.id;
        });

        if (
          localStorage.getItem("current_directory_id") == data.parent_directory
        ) {
          if (
            !files.includes(data.directory_children.id) &&
            data.who.includes(localStorage.getItem("id"))
          ) {
            that.UPDATE_DIRECTORY_CHILDREN(data.directory_children);
            that.SORT_DIRECTORY_CHILDREN();
          }
        }
      });

      createGroupFolderObservers.subscribe((data) => {
        if (data.who.includes(localStorage.getItem("id"))) {
          that.ADD_NOTIFICATION(data.message);
        }
      });

      this.user_data();

      let data = {
        token: cookies.getCookie("token"),
      };

      const iframenote = this.$refs.iframe_note;
      // view = 'note'|'chat'
      iframenote.addEventListener("load", () => {
        iframenote.contentWindow.postMessage({ view: "note" }, "*");
      });

      const iframechat = this.$refs.iframe_chat;
      // view = 'note'|'chat'
      iframechat.addEventListener("load", () => {
        iframechat.contentWindow.postMessage({ view: "chat" }, "*");
      });

      window.addEventListener("keyup", function (e) {
        if (e.which === 27) {
          if (that.$store.getters.SHOW_CHAT) {
            that.TOGGLE_CHAT();
          }

          if (that.$store.getters.SHOW_NOTE) {
            that.TOGGLE_NOTE();
          }
        }
      });
    } else {

      copyFileObservers.subscribe((data) => {
        let items = Object.keys(that.$store.getters.GET_FILES_INDEX);
        delete that.$store.getters.GET_FILES_INDEX[data.id];

        if (data.type === "move") {
          let files = that.$store.getters.DIRECTORY_CHILDREN.filter((file) => {
            if (file.id !== data.id) {
              file.is_checked = false;
              return file;
            }
          });

          that.SET_DIRECTORY_CHILDREN(files);
          that.SET_STORED_DIRECTORY_CHILDREN(files);
          that.SORT_DIRECTORY_CHILDREN();
        }
      });

      sharedFileObservers.subscribe((data) => {
        if (data.who.includes(localStorage.getItem("id"))) {
          let dataText = {
            id: data.message.id,
            text: data.message.message,
            is_checked: data.message.is_checked,
            is_read: data.message.is_read,
            createdAt: data.message.createAt,
          };
          that.UPDATE_NOTIFICATION(dataText);
          let notification = that.$store.getters.NOTIFICATION;
          let countnote = notification.map((note) => {
            if (!note.is_checked.includes(localStorage.getItem("id"))) {
              return true;
            }
          });
          that.UPDATE_NOTIFICATION_COUNT(countnote.length);
          // that.SORT_NOTIFICATION()
          let count = that.$store.getters.SHARED_WITH_ME_COUNT;
          ++count;
          that.UPDATE_SHARED_WITH_ME_COUNT(count);
        }
      });

      createFileObservers.subscribe((data) => {
        // console.log(data)
        let files = that.$store.getters.DIRECTORY_CHILDREN.map((file) => {
          return file.id;
        });

        if (
          localStorage.getItem("current_directory_id") == data.parent_directory
        ) {
          if (
            !files.includes(data.directory_children.id) &&
            data.who.includes(localStorage.getItem("id"))
          ) {
            that.UPDATE_DIRECTORY_CHILDREN(data.directory_children);
            that.SORT_DIRECTORY_CHILDREN();
          }
        }
      });

      createGroupFolderObservers.subscribe((data) => {
        // console.log(data)
        if (data.who.includes(localStorage.getItem("id"))) {
          // console.log(data.message)
          // that.ADD_NOTIFICATION(data.message)
        }
      });

      approveGroupFolderObservers.subscribe((data) => {
        if (data.who.includes(localStorage.getItem("id"))) {
        }
      });

      this.user_data();

      if (
        localStorage.getItem("current_directory_id") !== "undefined" &&
        localStorage.getItem("current_directory_id") != null &&
        localStorage.getItem("current_directory_id") != ""
      ) {
        let data = {
          token: cookies.getCookie("token"),
          current_directory_id: localStorage.getItem("current_directory_id"),
          db: localStorage.getItem("db"),
        };

        this.$socket.emit("get-current-directory", data, function (data) {
          if (data.data === true) {
            that.$refs.splash.close();
            localStorage.setItem(
              "current_directory_id",
              data.current_directory_id
            );
            localStorage.setItem("current_directory", data.current_directory);
            that.SET_DB(localStorage.getItem("db"));
            that.SET_DIRECTORY_CHILDREN(data.directory_children);
            that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
            that.SET_RECENT_FILES(data.recentFiles);
            that.SORT_DIRECTORY_CHILDREN();

            if (
              (data.group == "GROUP" || data.group == "PROJECT") &&
              String(data.current_directory_id) ===
              String(sessionStorage.getItem("gi"))
            ) {
              sessionStorage.setItem("is_group", true);
              sessionStorage.setItem("create_mode", true);
              that.SET_GROUP_CREATE_MODE(sessionStorage.getItem("create_mode"));
            } else {
              sessionStorage.setItem("group_create", data.create_right);
              sessionStorage.removeItem("create_mode");
              sessionStorage.setItem("is_group", true);
              that.SET_GROUP_CREATE_MODE(false);
            }

            if (data.group === "GROUP" || data.group === "PROJECT") {
              that.SET_CREATE_RIGHT(sessionStorage.getItem("group_create"));
              that.SET_DB(sessionStorage.getItem("group"));
              that.SET_CAN_CREATE(sessionStorage.getItem("create"));
              that.SET_EDIT_RIGHT(data.edit_right);
              that.SET_DOWNLOAD_RIGHT(data.download_right);
              that.SET_PRINT_RIGHT(data.print_right);
            }

            that.SET_PATH(data.dir_path);
          }

          if (data.data === false) {
            that.$router.push("/login");
            sessionStorage.removeItem("status");
          }
        });
      } else {
        if (localStorage.getItem("db") !== null) {
          if (localStorage.getItem("db") === "sharedwithme") {
            let data = {
              token: cookies.getCookie("token"),
            };

            this.SET_FILE_ACTION("");
            this.HIDE_FILE_INFO();
            this.SET_SELECT_ALL(false);
            this.EMPTY_FILES_INDEX();

            let that = this;

            this.$socket.emit("get-shared-with", data, function (data) {
              if (data.data === true) {
                that.$refs.splash.close();
                localStorage.setItem("current_directory_id", "");
                localStorage.setItem("current_directory", "Shared With Me");
                localStorage.setItem("db", "sharedwithme");
                that.SET_DB("sharedwithme");
                that.SET_DIRECTORY_CHILDREN(data.directory_children);
                that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
                that.SET_CURRENT_DIRECTORY("Shared With Me");
                that.SET_PATH(data.dir_path);
                that.SORT_DIRECTORY_CHILDREN();
              }

              if (data.data === false) {
                that.$refs.splash.close();
                that.logincall();
                sessionStorage.removeItem("status");
                that.$router.push('/login')
              }
            });
          }

          if (localStorage.getItem("db") === "sharedfiles") {
            let data = {
              token: cookies.getCookie("token"),
            };

            this.SET_FILE_ACTION("");
            this.HIDE_FILE_INFO();
            this.SET_SELECT_ALL(false);
            this.EMPTY_FILES_INDEX();

            let that = this;

            this.$socket.emit("get-shared-files", data, function (data) {
              if (data.data === true) {
                that.$refs.splash.close();
                localStorage.setItem("current_directory_id", "");
                localStorage.setItem("current_directory", "Shared Files");
                localStorage.setItem("db", "sharedfiles");
                that.SET_DB("sharedfiles");
                that.SET_DIRECTORY_CHILDREN(data.directory_children);
                that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
                that.SET_CURRENT_DIRECTORY("Shared Files");
                that.SET_PATH(data.dir_path);
                that.SORT_DIRECTORY_CHILDREN();
              }

              if (data.data === false) {
                that.$refs.splash.close();
                that.logincall(true);
                sessionStorage.removeItem("status");
                that.$router.push('/login')
              }
            });
          }

          if (localStorage.getItem("db") === "public") {
            let data = {
              token: cookies.getCookie("token"),
              db: localStorage.getItem("db"),
            };

            this.SET_FILE_ACTION("");
            this.HIDE_FILE_INFO();
            this.SET_SELECT_ALL(false);

            let that = this;

            this.$socket.emit("browse-public", data, function (data) {
              if (data.data === true) {
                that.$refs.splash.close();
                localStorage.setItem("current_directory_id", "");
                localStorage.setItem("current_directory", "Public");
                localStorage.setItem("db", "public");
                that.SET_DB("public");
                that.SET_DIRECTORY_CHILDREN(data.directory_children);
                that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
                that.SET_CURRENT_DIRECTORY("Public");
                that.SET_PATH(data.dir_path);
                that.SORT_DIRECTORY_CHILDREN();
              }

              if (data.data === false) {
                that.$router.push("/login");
                sessionStorage.removeItem("status");
              }
            });
          }

          if (localStorage.getItem("db") === "trash") {
            let data = {
              token: cookies.getCookie("token"),
            };

            this.SET_FILE_ACTION("");
            this.HIDE_FILE_INFO();
            this.SET_SELECT_ALL(false);

            let that = this;

            this.$socket.emit("get-trash-files", data, function (data) {
              if (data.data === true) {
                that.$refs.splash.close();
                localStorage.setItem("current_directory_id", "");
                localStorage.setItem("current_directory", "Trash");
                localStorage.setItem("db", "trash");
                that.SET_DB("filesystem");
                that.SET_DIRECTORY_CHILDREN(data.directory_children);
                that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
                that.SET_CURRENT_DIRECTORY("Trash");
                that.SET_PATH(data.dir_path);
                that.SORT_DIRECTORY_CHILDREN();
              }

              if (data.data === false) {
                that.$router.push("/login");
                sessionStorage.removeItem("status");
              }
            });
          }

          if (localStorage.getItem("db") === "favourite") {
            this.HIDE_FILE_INFO();
            this.SET_FILE_ACTION("");
            this.SET_SELECT_ALL(false);

            let data = {
              token: cookies.getCookie("token"),
            };

            let that = this;

            this.$socket.emit("myfav", data, function (data) {
              if (data.data === true) {
                that.$refs.splash.close();
                localStorage.setItem("current_directory", "My Favourite");
                localStorage.setItem("db", "favourite");
                that.SET_DB("filesystem");
                that.SET_DIRECTORY_CHILDREN(data.directory_children);
                that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
                that.SET_CURRENT_DIRECTORY("My Favourite");
                that.SET_PATH(data.dir_path);
                that.SORT_DIRECTORY_CHILDREN();
              }

              if (data.data === false) {
                that.$router.push("/login");
                sessionStorage.removeItem("status");
              }
            });
          }

          if (localStorage.getItem("db") === "group") {
            if (localStorage.getItem("current_directory_id") === undefined) {
              let data = {
                token: cookies.getCookie("token"),
                db: "group",
              };

              this.$socket.emit("browse", data, function (data) {
                if (data.data === true) {
                  that.$refs.splash.close();
                  localStorage.setItem("current_directory_id", undefined);
                  localStorage.setItem("current_directory", "Group");
                  localStorage.setItem("db", "group");
                  that.SET_DB("group");
                  that.SET_CAN_CREATE(false);
                  that.SET_DIRECTORY_CHILDREN(data.directory_children);
                  that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
                  that.SET_CURRENT_DIRECTORY("Group");
                  that.SET_PATH(data.dir_path);
                  that.SORT_DIRECTORY_CHILDREN();
                }

                if (data.data === false) {
                  that.$router.push("/login");
                  sessionStorage.removeItem("status");
                }
              });
            } else {
              let data = {
                token: cookies.getCookie("token"),
                current_directory_id: localStorage.getItem(
                  "current_directory_id"
                ),
                db: "group",
              };

              this.$socket.emit("browse", data, function (data) {
                if (data.data === true) {
                  that.$refs.splash.close();
                  that.SET_DIRECTORY_CHILDREN(data.directory_children);
                  that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
                  that.SORT_DIRECTORY_CHILDREN();
                }

                if (data.data === false) {
                  that.$router.push("/login");
                  sessionStorage.removeItem("status");
                }
              });
            }
          }

          if (localStorage.getItem("db") === "filesystem") {
            let data = {
              token: cookies.getCookie("token"),
            };

            this.$socket.emit("eb:auth", data, function (data) {
              if (data.data === true) {
                that.$refs.splash.close();
                localStorage.setItem(
                  "current_directory_id",
                  data.current_directory_id
                );
                localStorage.setItem(
                  "current_directory",
                  data.current_directory
                );
                localStorage.setItem("db", "filesystem");
                that.SET_DB("filesystem");
                that.SET_PATH([]);
                that.SET_DIRECTORY_CHILDREN(data.directory_children);
                that.SET_RECENT_FILES(data.recentFiles);
                that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
                that.SORT_DIRECTORY_CHILDREN();
              }

              if (data.data === false) {
                that.$router.push("/login");
                sessionStorage.removeItem("status");
              }
            });
          }
        } else {
          let data = {
            token: cookies.getCookie("token"),
          };

          this.$socket.emit("eb:auth", data, function (data) {
            if (data.data === true) {
              // console.log(data);
              that.$refs.splash.close();
              localStorage.setItem(
                "current_directory_id",
                data.current_directory_id
              );
              localStorage.setItem("current_directory", data.current_directory);
              localStorage.setItem("db", "filesystem");
              that.SET_DB("filesystem");
              that.SET_PATH([]);
              that.SET_DIRECTORY_CHILDREN(data.directory_children);
              that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
              that.SET_RECENT_FILES(data.recentFiles);
              that.SORT_DIRECTORY_CHILDREN();
            }

            if (data.data === false) {
              that.$router.push("/login");
              sessionStorage.removeItem("status");
            }
          });
        }
      }

      let data = {
        token: cookies.getCookie("token"),
      };

      this.$socket.emit("eb:notification", data, function (data) {
        if (data.data === true) {
          let count = data.notifications.filter((note) => {
            if (!note.is_checked.includes(localStorage.getItem("id"))) {
              return true;
            }
          });

          that.UPDATE_NOTIFICATION_COUNT(count.length);
          that.ADD_NOTIFICATION(data.notifications);
        }
      });

      const iframenote = this.$refs.iframe_note;
      // view = 'note'|'chat'
      iframenote.addEventListener("load", () => {
        iframenote.contentWindow.postMessage({ view: "note" }, "*");
      });

      const iframechat = this.$refs.iframe_chat;
      // view = 'note'|'chat'
      iframechat.addEventListener("load", () => {
        iframechat.contentWindow.postMessage({ view: "chat" }, "*");
      });

      window.addEventListener("keyup", function (e) {
        if (e.which === 27) {
          if (that.$store.getters.SHOW_CHAT) {
            that.TOGGLE_CHAT();
          }

          if (that.$store.getters.SHOW_NOTE) {
            that.TOGGLE_NOTE();
          }
        }
      });
    }
  },
};
</script>
